import { configureStore } from "@reduxjs/toolkit";
import jobsReducer from "./jobsSlice";
import configReducer from "./configSlice";
import countryReducer from "./countrySice";

export const store = configureStore({
  reducer: {
    jobs: jobsReducer,
    configs: configReducer,
    country: countryReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: true }),
});
